import { complianceGlob } from "./compliance";
import { typesGlob } from "./types";

const rootArea = "/reporting";

export const reportingGlob = () => ({
	self: rootArea,
	compliance: complianceGlob(rootArea),
	types: typesGlob(rootArea)
});
